import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.posts');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { AWESOME_LLM_APP_SECTIONS } from '../awesome-llm-apps-catalog';

interface DocEntry {
    id: string;
    title: string;
    category: string;
    summary: string;
    href?: string;
    keywords: string[];
}

interface DocSection {
    id: string;
    order: string;
    title: string;
    summary: string;
    entries: DocEntry[];
}

interface FeaturedDoc {
    id: string;
    label: string;
    title: string;
    summary: string;
    meta: string;
    href: string;
    tone: 'teal' | 'blue' | 'amber';
}

const CATALOG_SECTIONS: DocSection[] = AWESOME_LLM_APP_SECTIONS.map((section) => ({
    id: section.id,
    order: section.order,
    title: section.title,
    summary: section.summary,
    entries: section.entries.map((item) => ({
        id: item.id,
        title: item.title,
        category: item.category,
        summary: item.summary,
        href: item.href,
        keywords: item.keywords,
    })),
}));

const benchmarkSection = CATALOG_SECTIONS.find((section) => section.id === 'benchmarks');
const codexSection = CATALOG_SECTIONS.find((section) => section.id === 'codex-skills');
const frameworkSection = CATALOG_SECTIONS.find((section) => section.id === 'frameworks');
const benchmarkHubEntry = benchmarkSection?.entries.find((entry) => entry.id === 'benchmark-hub');
const frameworkEntry = frameworkSection?.entries[0];
const codexGoalEntry = codexSection?.entries.find((entry) => entry.id === 'codex-skill-goal');

@Component({
    selector: 'wiz-page-posts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.posts/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100vh;
  color: #172033;
  background: #f6f7f9;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
  box-sizing: border-box;
}

.posts-shell {
  width: 100%;
  min-width: 0;
  min-height: 100vh;
  background: #f6f7f9;
  box-sizing: border-box;
}

.posts-shell * {
  box-sizing: border-box;
}

.posts-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #cfd6df;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
}

.posts-header__inner,
.posts-command__inner,
.posts-section__inner,
.posts-index__inner {
  width: min(1360px, 100% - 48px);
  margin: 0 auto;
}

.posts-header__inner {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.posts-brand {
  display: flex;
  align-items: center;
  width: 158px;
  min-width: 140px;
  color: #111827;
  text-decoration: none;
}

.posts-brand__text {
  color: inherit;
  font-size: 19px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0;
  white-space: nowrap;
}

.posts-nav {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.posts-nav a {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  padding: 0 12px;
  color: #344054;
  font-size: 14px;
  font-weight: 850;
  text-decoration: none;
}

.posts-nav a:hover,
.posts-nav a:focus-visible {
  color: #1d4f91;
  background: #eaf1fb;
  outline: none;
}

.posts-command {
  border-bottom: 1px solid #cfd6df;
  background: #ffffff;
}

.posts-command__inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 380px);
  gap: 32px;
  padding: 30px 0;
  align-items: end;
}

.posts-intro {
  min-width: 0;
}

.posts-kicker {
  margin: 0 0 8px;
  color: #006a67;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
}

.posts-intro h1,
.posts-section__head h2,
.result-toolbar h2 {
  margin: 0;
  color: #101828;
  line-height: 1.22;
  font-weight: 900;
  letter-spacing: 0;
}

.posts-intro h1 {
  font-size: 34px;
}

.posts-section__head h2,
.result-toolbar h2 {
  font-size: 24px;
}

.posts-intro p:last-of-type,
.posts-section__head p {
  max-width: 760px;
  margin: 10px 0 0;
  color: #586474;
  font-size: 15px;
  line-height: 1.65;
  font-weight: 650;
}

.posts-search {
  width: min(780px, 100%);
  margin-top: 20px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 96px;
  border: 1px solid #98a2b3;
  border-radius: 6px;
  background: #ffffff;
  overflow: hidden;
}

.posts-search input {
  min-width: 0;
  height: 50px;
  border: 0;
  padding: 0 16px;
  color: #172033;
  background: transparent;
  font: inherit;
  font-size: 15px;
  font-weight: 650;
  outline: none;
}

.posts-search input::placeholder {
  color: #7a8493;
}

.posts-search button {
  height: 50px;
  border: 0;
  border-left: 1px solid #98a2b3;
  color: #ffffff;
  background: #1d4f91;
  font: inherit;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
}

.posts-search button:hover,
.posts-search button:focus-visible {
  background: #163f75;
  outline: none;
}

.posts-stats {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #cfd6df;
  border-radius: 8px;
  background: #fbfcfe;
  overflow: hidden;
}

.posts-stats div {
  min-width: 0;
  min-height: 92px;
  display: grid;
  align-content: center;
  gap: 4px;
  padding: 16px;
  border-right: 1px solid #e4e7ec;
  border-bottom: 1px solid #e4e7ec;
}

.posts-stats div:nth-child(2n) {
  border-right: 0;
}

.posts-stats div:nth-last-child(-n+2) {
  border-bottom: 0;
}

.posts-stats strong {
  color: #101828;
  font-size: 28px;
  line-height: 1;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.posts-stats span {
  color: #667085;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 800;
}

.featured-docs {
  background: #f6f7f9;
}

.posts-section__inner {
  padding: 30px 0 12px;
}

.posts-section__head {
  margin-bottom: 16px;
}

.featured-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.featured-doc {
  min-width: 0;
  min-height: 190px;
  display: grid;
  align-content: start;
  gap: 10px;
  border: 1px solid #cfd6df;
  border-radius: 8px;
  padding: 22px;
  color: inherit;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  text-decoration: none;
}

.featured-doc:hover,
.featured-doc:focus-visible {
  border-color: #1d4f91;
  outline: none;
}

.featured-doc span {
  font-size: 12px;
  line-height: 1.45;
  font-weight: 900;
}

.featured-doc strong {
  min-width: 0;
  color: #101828;
  font-size: 21px;
  line-height: 1.3;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.featured-doc p {
  margin: 0;
  color: #586474;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 650;
}

.featured-doc small {
  align-self: end;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 850;
}

.featured-doc--teal span,
.featured-doc--teal small {
  color: #006a67;
}

.featured-doc--blue span,
.featured-doc--blue small {
  color: #1d4f91;
}

.featured-doc--amber span,
.featured-doc--amber small {
  color: #b54708;
}

.posts-index__inner {
  display: grid;
  grid-template-columns: minmax(210px, 240px) minmax(0, 1fr);
  gap: 30px;
  padding: 30px 0 72px;
  align-items: start;
}

.posts-directory {
  position: sticky;
  top: 96px;
  min-width: 0;
}

.posts-directory h2 {
  margin: 0 0 12px;
  color: #101828;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 900;
  letter-spacing: 0;
}

.directory-list {
  display: grid;
  border-top: 1px solid #cfd6df;
}

.directory-list button {
  min-width: 0;
  min-height: 58px;
  display: grid;
  gap: 4px;
  border: 0;
  border-bottom: 1px solid #cfd6df;
  border-left: 3px solid transparent;
  padding: 10px 8px 10px 12px;
  color: #344054;
  background: transparent;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.directory-list button:hover,
.directory-list button:focus-visible,
.directory-list button.is-active {
  border-left-color: #1d4f91;
  background: #eaf1fb;
  outline: none;
}

.directory-list strong {
  min-width: 0;
  color: #172033;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.directory-list span {
  color: #667085;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 750;
}

.posts-content {
  min-width: 0;
}

.result-toolbar {
  min-width: 0;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.clear-button {
  min-height: 36px;
  flex: 0 0 auto;
  border: 1px solid #98a2b3;
  border-radius: 6px;
  padding: 0 12px;
  color: #344054;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 850;
  cursor: pointer;
}

.clear-button:hover,
.clear-button:focus-visible {
  border-color: #1d4f91;
  color: #1d4f91;
  outline: none;
}

.empty-state {
  margin: 0;
  border-top: 2px solid #172033;
  padding: 20px 0;
  color: #586474;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 750;
}

.post-section {
  min-width: 0;
  margin-bottom: 30px;
  border-top: 2px solid #172033;
}

.post-section:last-child {
  margin-bottom: 0;
}

.post-section__head {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 18px;
  padding: 14px 0;
  border-bottom: 1px solid #cfd6df;
}

.post-section__head > span {
  color: #667085;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 850;
  font-variant-numeric: tabular-nums;
}

.post-section__head h3 {
  margin: 0;
  color: #101828;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 900;
  letter-spacing: 0;
}

.post-section__head p {
  margin: 4px 0 0;
  color: #586474;
  font-size: 14px;
  line-height: 1.65;
  font-weight: 650;
}

.post-entry-list {
  display: grid;
}

.post-entry {
  min-width: 0;
  display: grid;
  grid-template-columns: 136px minmax(150px, 260px) minmax(220px, 1fr) 88px;
  gap: 16px;
  align-items: baseline;
  padding: 12px 0;
  border-bottom: 1px solid #e4e7ec;
  color: inherit;
  text-decoration: none;
}

.post-entry:hover strong,
.post-entry:focus-visible strong {
  color: #1d4f91;
}

.post-entry:focus-visible {
  outline: 2px solid #1d4f91;
  outline-offset: 2px;
}

.post-entry.is-planned {
  cursor: default;
}

.post-entry.is-planned:hover strong {
  color: #101828;
}

.post-entry__category {
  min-width: 0;
  color: #b54708;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.post-entry strong {
  min-width: 0;
  color: #101828;
  font-size: 15px;
  line-height: 1.45;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.post-entry small {
  min-width: 0;
  color: #586474;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.post-entry__status {
  color: #1d4f91;
  font-size: 13px;
  font-weight: 850;
  text-align: right;
  white-space: nowrap;
}

.post-entry.is-planned .post-entry__status {
  color: #98a2b3;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1180px) {
  .posts-command__inner {
    grid-template-columns: minmax(0, 1fr) 320px;
    gap: 24px;
  }
  .posts-index__inner {
    grid-template-columns: 200px minmax(0, 1fr);
  }
  .post-entry {
    grid-template-columns: 112px minmax(130px, 220px) minmax(180px, 1fr) 80px;
  }
}
@media (max-width: 900px) {
  .posts-command__inner,
  .posts-index__inner {
    grid-template-columns: 1fr;
  }
  .posts-directory {
    position: static;
  }
  .directory-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-left: 1px solid #cfd6df;
  }
  .directory-list button {
    border-right: 1px solid #cfd6df;
  }
  .featured-grid {
    grid-template-columns: 1fr;
  }
  .featured-doc {
    min-height: 0;
  }
}
@media (max-width: 640px) {
  .posts-header__inner,
  .posts-command__inner,
  .posts-section__inner,
  .posts-index__inner {
    width: min(100% - 28px, 1360px);
  }
  .posts-header__inner {
    min-height: auto;
    padding: 14px 0;
    align-items: flex-start;
    flex-direction: column;
  }
  .posts-brand {
    width: 146px;
  }
  .posts-nav {
    justify-content: flex-start;
  }
  .posts-command__inner {
    padding: 22px 0;
  }
  .posts-intro h1 {
    font-size: 29px;
  }
  .posts-search,
  .post-entry {
    grid-template-columns: 1fr;
  }
  .posts-search button {
    border-left: 0;
    border-top: 1px solid #98a2b3;
  }
  .posts-stats {
    grid-template-columns: 1fr;
  }
  .posts-stats div,
  .posts-stats div:nth-child(2n),
  .posts-stats div:nth-last-child(-n+2) {
    border-right: 0;
    border-bottom: 1px solid #e4e7ec;
  }
  .posts-stats div:last-child {
    border-bottom: 0;
  }
  .directory-list,
  .post-section__head {
    grid-template-columns: 1fr;
  }
  .directory-list button {
    border-right: 0;
  }
  .result-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .clear-button {
    align-self: flex-start;
  }
  .post-entry {
    gap: 4px;
    align-items: start;
  }
  .post-entry__status {
    text-align: left;
  }
}`],
})
export class PagePostsComponent implements OnInit {
    public readonly benchmarkCount = benchmarkSection?.entries.length || 0;
    public readonly featuredDocs: FeaturedDoc[] = [
        {
            id: benchmarkHubEntry?.id || 'benchmark-hub',
            label: '벤치마크',
            title: benchmarkHubEntry?.title || 'LLM Agent Benchmarks',
            summary: benchmarkHubEntry?.summary || '최신 모델 그래프와 하위 벤치마크 상세 문서를 모은 내부 조사 허브입니다.',
            meta: `${this.benchmarkCount}개 벤치마크 상세 · 최신 모델 그래프`,
            href: benchmarkHubEntry?.href || '/benchmarks/llm-agent',
            tone: 'teal',
        },
        {
            id: frameworkEntry?.id || 'caveman-framework',
            label: '프레임워크',
            title: frameworkEntry?.title || 'Caveman',
            summary: frameworkEntry?.summary || '코딩 에이전트 응답 규칙을 압축형 커뮤니케이션 프로토콜로 정리한 LLM 프레임워크입니다.',
            meta: frameworkSection?.title || 'LLM Frameworks',
            href: frameworkEntry?.href || '/frameworks/caveman',
            tone: 'blue',
        },
        {
            id: codexGoalEntry?.id || 'codex-skill-goal',
            label: 'Codex 스킬',
            title: codexGoalEntry?.title || 'Codex /goal',
            summary: codexGoalEntry?.summary || '긴 작업을 세션 목표로 고정하고 완료 조건까지 추적하는 스킬입니다.',
            meta: `${codexSection?.entries.length || 0}개 Codex 스킬 · 사용/미사용 비교`,
            href: codexGoalEntry?.href || '/codex-skills/goal',
            tone: 'amber',
        },
    ];

    public readonly sections: DocSection[] = CATALOG_SECTIONS;
    public selectedSectionId = 'all';
    public searchQuery = '';

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,    ) { }

    public get allEntries(): DocEntry[] {
        return this.sections.reduce((entries, section) => entries.concat(section.entries), [] as DocEntry[]);
    }

    public get availableEntryCount(): number {
        return this.allEntries.filter((entry) => entry.href).length;
    }

    public get visibleSections(): DocSection[] {
        const query = this.normalize(this.searchQuery);

        return this.activeSections
            .map((section) => {
                if (!query) {
                    return section;
                }

                return {
                    ...section,
                    entries: section.entries.filter((entry) => this.matchesEntry(entry, query)),
                };
            })
            .filter((section) => section.entries.length > 0);
    }

    public get visibleEntryCount(): number {
        return this.visibleSections.reduce((total, section) => total + section.entries.length, 0);
    }

    public get selectedSectionLabel(): string {
        if (this.selectedSectionId === 'all') {
            return '전체 조사 문서';
        }

        const section = this.sections.find((item) => item.id === this.selectedSectionId);
        return section ? section.title : '전체 조사 문서';
    }

    public async ngOnInit() {
        await this.service.init();
    }

    public onSearchInput(event: Event) {
        const input = event.target as HTMLInputElement;
        this.searchQuery = input.value || '';
    }

    public submitSearch(event: Event) {
        event.preventDefault();

        const query = this.searchQuery.trim();

        if (!query) {
            return;
        }

        this.router.navigateByUrl(`/search?q=${encodeURIComponent(query)}`);
    }

    public selectSection(sectionId: string) {
        this.selectedSectionId = sectionId;
    }

    public clearSearch() {
        this.searchQuery = '';
    }

    public trackByFeaturedDoc(_: number, doc: FeaturedDoc) {
        return doc.id;
    }

    public trackBySection(_: number, section: DocSection) {
        return section.id;
    }

    public trackByEntry(_: number, entry: DocEntry) {
        return entry.id;
    }

    private get activeSections(): DocSection[] {
        if (this.selectedSectionId === 'all') {
            return this.sections;
        }

        return this.sections.filter((section) => section.id === this.selectedSectionId);
    }

    private matchesEntry(entry: DocEntry, query: string): boolean {
        const haystack = this.normalize([
            entry.title,
            entry.category,
            entry.summary,
            entry.keywords.join(' '),
        ].join(' '));

        return haystack.includes(query);
    }

    private normalize(value: string): string {
        return value.toLowerCase().trim();
    }
}

export default PagePostsComponent;